import { useMemo } from "react";

import { getXtenantId } from "../../../utils/utils";
import { useGetClaimIntegration } from "./use-get-claim-integration";

export type ClearinghouseVendor = "WAYSTAR" | "CLAIM_MD" | "STEDI";

const KNOWN_VENDORS: Set<ClearinghouseVendor> = new Set([
  "WAYSTAR",
  "CLAIM_MD",
  "STEDI",
]);

/**
 * Resolves the clearinghouse vendors configured (non-archived) in the
 * Configuration tab. Used at claim-submission entry points to decide whether
 * the vendor-selection screen is needed: when exactly one clearinghouse is
 * configured the claim is submitted directly to it, skipping the picker.
 */
export function useConfiguredClearinghouses() {
  const { data, isLoading } = useGetClaimIntegration({
    xtenantId: getXtenantId() ?? "",
  });

  const vendors = useMemo<ClearinghouseVendor[]>(
    () =>
      (((data as any)?.data as any[]) ?? [])
        .filter(
          (it) =>
            !it?.archive && KNOWN_VENDORS.has(it?.vendor as ClearinghouseVendor)
        )
        .map((it) => it.vendor as ClearinghouseVendor),
    [data]
  );

  return {
    vendors,
    isLoading,
    // The single configured vendor, or null when there are zero or multiple.
    singleVendor: vendors.length === 1 ? vendors[0] : null,
  };
}
